
export default {

    newCreatedPerformance: (state) => {
        return state.newCreatedPerformance
    }
}